import { v4 as uuidv4 } from "uuid";

// Device-level identity used by event tracking. It lives outside helper-methods.ts so pages that never
// sign anyone in (the marketing site at jungleai.com) can track events without loading the app's runtime;
// the deviceUID key is shared with the app, so a visitor's marketing-site events and their in-app
// events after the handoff carry the same deviceId.

export const getOrCreateDeviceUID = (): string => {
  let deviceUID = localStorage.getItem("deviceUID");
  if (!deviceUID) {
    deviceUID = uuidv4(); // Generate a unique UID
    localStorage.setItem("deviceUID", deviceUID);
  }
  return deviceUID;
};

export const detectOS = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const platform = window.navigator.platform.toLowerCase();

  if (/win/.test(platform)) {
    return "Windows";
  } else if (/mac/.test(platform)) {
    return "MacOS";
  } else if (/linux/.test(platform)) {
    return "Linux";
  } else if (/android/.test(userAgent)) {
    return "Android";
  } else if (/iphone|ipad|ipod/.test(userAgent) || /iphone|ipad|ipod/.test(platform)) {
    return "iOS";
  } else {
    return "Unknown OS";
  }
};
